<template>
  <div class="portal" :class="{ 'portal-preview-mode': $portalPreview }">
    <div v-if="$portalPreview" class="portal-preview-bar" role="status">
      <span>{{ $portalStatus.previewError ? '草稿预览失败：' + $portalStatus.previewError + '。当前显示内置内容。' : '草稿预览 · 尚未发布 · 版本 ' + $portalStatus.revision }}</span>
      <button type="button" @click="$exitPortalPreview">退出预览</button>
    </div>
    <template v-if="filterSepcialRoute">
    </template>
    <template v-else>
      <slider-nav />
      <div class="portal-content">
        <router-view />
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'portal',
  data() {
    return {
    }
  },
  computed: {
    filterSepcialRoute() {
      return false
    }
  }
}
</script>
<style lang="less" scoped>
@import url('./index.less');
.portal-preview-bar { position: fixed; top: 0; left: 0; right: 0; z-index: 100000; min-height: 44px; background: #fff7d6; color: #6b4c00; display: flex; align-items: center; justify-content: center; gap: 20px; padding: 8px 16px; font-size: 16px; }
.portal-preview-bar * { font-size: 16px; }
.portal-preview-bar button { border: 1px solid #ae8a27; border-radius: 4px; padding: 4px 12px; background: #fff; cursor: pointer; }
.portal-preview-mode { padding-top: 52px; }
.portal-preview-mode ::v-deep .portal-nav { top: 52px; }

</style>